import { useEffect, useState } from "react";

export default function ModalContent({ movieModal }) {
    const moviePoster1 = 'https://image.tmdb.org/t/p/w300';

    async function getData() {
        return fetch(`https://api.themoviedb.org/3/movie/${movieModal.id}?api_key=${process.env.REACT_APP_TMDB_API_KEY}&append_to_response=videos`)
        .then(data => data.json());
    }
    const [data, setData] = useState(null);
    const [hasMovieTrailer, setHasMovieTrailer] = useState(null);
    const [movieTrailers, setMovieTrailers] = useState(null);
    
    async function initializeData() {
        const data = await getData();
        setData(data);
        if (data.videos.results.length !== 0) {
            setHasMovieTrailer(data.videos.results);
            console.log('There are movie trailers for this film: ', data.videos.results);
        } else {
            setHasMovieTrailer(null);
        }
        console.log('data is:', data);
    }

    const moviePoster = () => {
        const moviePoster2 = data.poster_path;
        const backgroundStyling = {
        backgroundImage: `url(${moviePoster1 + moviePoster2})`,
        backgroundPosition: 'cover',
        height: '450px',
        width: '300px',
        borderRadius: '14px'
        };
        return backgroundStyling;
    }

    const renderMovieData = () => {
        if (data && movieTrailers) {
            return (
            <div className="container-fluid w-100 h-100">
                <div className="row bg-dark movie-title mt-4 d-flex justfy-content-end">
                    <div className="movie-title">
                        <h2>{data.original_title}</h2>
                    </div>
                </div>
                <div className="row movie-info w-100 col-12 mt-3 d-flex justify-content-around">
                    <div className="col-5" style={moviePoster()}></div>
                    <div className="col-7 mt-3">
                        <div className="container-fluid description">
                            <div className="row">
                                <h4>Description:</h4> {data.overview} <br/><br/><br/>
                            </div>
                            <div className="row">
                                <div className="col-6 genres">
                                    { <ul>
                                        <h4>Genre:</h4> {data.genres.map((obj) => (
                                        <li key={obj.id} className="p-0">
                                            <h5>{obj.name}</h5>
                                        </li>
                                        ))}
                                    </ul> }
                                </div>
                                <div className="col-6">
                                    <h4>Vote average:</h4><br/> <h5>{data.vote_average}</h5>
                                </div>
                            </div>
                        </div>


                    </div>    
                </div>
                <div className="row w-100 trailers">
                    <div className="col-12">
                        <h2>Trailers</h2>
                        {movieTrailers.map((trailerPair, rowIndex) => (
                            <div key={rowIndex}>
                            {trailerPair.map((trailer, cellIndex) => {
                                if (trailer) {
                                    // return <video className="m-3" key={cellIndex} controls src={`https://www.youtube.com/embed/${trailer.key}`} width="300"></video>
                                    return <iframe className="ms-4 mb-4" width="300" src={`https://www.youtube.com/embed/${trailer.key}`} title={`YouTube video player ${cellIndex}`} frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                                } else {
                                    return <div></div>
                                }
                                })}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            )
        } else if (data) {
            return (
                <div className="container-fluid w-100 h-100">
                    <div className="row w-100 bg-dark movie-title mt-5">
                        <div className="movie-title">
                            <h3>{data.original_title}</h3>
                        </div>
                    </div>
                    <div className="row w-100 h-75 mt-3">
                        <div className="col-5" style={moviePoster()}></div>
                        <div className="col-7 ms-3 border border-dark">
                            <div className="container-fluid description">
                                <div className="row">
                                    <span style={{fontWeight: 'bold'}}>Description:</span> {data.overview} <br/><br/><br/>
                                </div>
                                <div className="row">
                                    <div className="col-6 genres">
                                        { <ul>
                                            <span className="fw-bold">Genre</span>: {data.genres.map((obj) => (
                                            <li key={obj.id} className="p-0">
                                                {obj.name}
                                            </li>
                                            ))}
                                        </ul> }
                                    </div>
                                    <div className="col-6">
                                    <span className="fw-bold">Vote average:</span><br/> {data.vote_average}
                                    </div>
                                </div>
                            </div>
                        </div>    
                        </div>
                        <div className="row w-100 trailers">
                            <div className="col-12">
                                <h2>Trailers</h2>
                                <span className="font-weight-bold">There are no trailers for your selection</span>
                            </div>
                        </div>
                </div>
            )

        } else {
            return (
                <div className="container-fluid w-100 h-100"></div>
            )
        }
    };

    useEffect(() => {
        //if ensures that function only runs when a movie is clicked on
        if (movieModal) {
            initializeData()
        }
    }, [movieModal])

    useEffect(() => {
        if (hasMovieTrailer) {
            let copy = [];
            let i = 0;
            while(i < hasMovieTrailer.length) {
                let innerArray = [];
                let j = 0;
                while (j < 2) {
                    innerArray.push(hasMovieTrailer[i]);
                    i++;
                    j++;
                }
                copy.push(innerArray);
            }
            console.log('array of trailers: ', copy);
            setMovieTrailers(copy);
        } else {
            setMovieTrailers(null);
        }
    }, [hasMovieTrailer])

    return (
        <>
            {renderMovieData()}
        </>
    )
}